<template>
    <div>
        <rd-popup v-if="popupVisible" :visibility="popupVisible" :title="$t('add.title')">
            <dx-validation-group :ref="`validationGroup`" @initialized="validationGroupInitialized">
                <rd-popup-content>
                    <div class="row">
                        <rd-column :size="$columns.TwelveOnLg">
                            <rd-form-group :label="$t('add.label.CountryName')">
                                <dx-text-box v-model="CountryName">
                                    <dx-validator>
                                        <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                        <DxAsyncRule :validation-callback="validateCountryExistance" :message="$t('validation.validation')" />
                                    </dx-validator>
                                </dx-text-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.TwelveOnLg">
                            <rd-form-group :label="$t('add.label.CountryShortcut')">
                                <dx-text-box v-model="CountryShortcut">
                                    <dx-validator>
                                        <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                        <DxAsyncRule :validation-callback="validateCountryExistance" :message="$t('validation.validation')" />
                                    </dx-validator>
                                </dx-text-box>
                            </rd-form-group>
                        </rd-column>
                        <rd-column :size="$columns.TwelveOnLg">
                            <rd-form-group :label="$t('add.label.Regex')">
                                <dx-text-box v-model="Regex">
                                    <dx-validator>
                                        <dx-required-rule :message="$t('fieldRules.reuiredShort')" />
                                    </dx-validator>
                                </dx-text-box>
                            </rd-form-group>
                        </rd-column>
                    </div>
                </rd-popup-content>
                <rd-popup-actions>
                    <dx-button :use-submit-behavior="false"
                               styling-mode="text"
                               type="normal"
                               :text="$t('buttons.cancel')"
                               @click="closePopup">
                    </dx-button>
                    <dx-button :use-submit-behavior="false"
                               type="default"
                               class="ml-1"
                               :text="$t('buttons.save')"
                               @click="closePopupOnSave">
                    </dx-button>
                </rd-popup-actions>
            </dx-validation-group>
        </rd-popup>
    </div>
</template>

<script>
    // @ is an alias to /src
    import DxTextBox from 'devextreme-vue/text-box';
    import DxButton from 'devextreme-vue/button';
    import {
        DxRequiredRule,
        DxValidator,
        DxAsyncRule
    } from 'devextreme-vue/validator';
    import DxValidationGroup from 'devextreme-vue/validation-group';

    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { mapFields } from 'vuex-map-fields';
    import commonMessages from '../../locales';
    import localMessages from '../locales';
    const name = "administrationStores/dictionariesStores/nipMaskStores/addStore";
    export default {
        name: 'nipMaskAdd',
        data() {
            return {
                popupVisible: false,
                pageSizes: [30, 50, 100]
            }
        },
        computed: {
            ...mapGetters(name, ['getForm', 'getNipMaskDataSource']),
            ...mapFields(name, [
                'addForm.CountryName',
                'addForm.CountryShortcut',
                'addForm.Regex'
            ]),
        },
        methods: {
            ...mapActions(name, ['setDetails', 'addNipMask', 'setNipMaskDataSource', 'validateCountryExistance']),
            ...mapMutations(name, ['resetForm']),
            closePopup: function () {
                this.popupVisible = false;
                this.resetForm();
            },
            closePopupOnSave: function (e) {
                e.validationGroup.validate().complete.then((validateResult) => {
                    if (validateResult.isValid) {
                        this.addNipMask().then(() => {
                            this.popupVisible = false;
                            this.$emit('added');
                            this.resetForm();
                        });
                    }
                })
            },

            show() {
                this.popupVisible = true;
            },
            validationGroupInitialized(e) {
                let localthis = this;
                setTimeout(function () {
                    localthis.$refs["validationGroup"].instance.validate();
                }, 0);
            },
        },
        mounted() {
            this.setDetails();
            this.setNipMaskDataSource();
        },
        components: {
            DxButton,
            DxValidationGroup,
            DxValidator,
            DxRequiredRule,
            DxTextBox,
            DxAsyncRule
        },
        i18n: {
            messages: localMessages.messages,
            sharedMessages: commonMessages.messages
        }
    }
</script>
